import { defineMessages } from 'react-intl'

export default defineMessages({
  label: {
    id: 'containers.OrderPage.components.TaskPage.components.DeleteTaskMenuItem.label',
    defaultMessage: 'Delete {taskType}',
  },
  confirmPrompt: {
    id: 'containers.OrderPage.components.TaskPage.components.DeleteTaskMenuItem.confirmPrompt',
    defaultMessage: 'Are you sure you want to delete this {taskType}?',
  },
  success: {
    id: 'containers.OrderPage.components.TaskPage.components.DeleteTaskMenuItem.success',
    defaultMessage: '{taskType} deleted',
  },
})
